import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MyContextType {
  value: string;
  setValue: (newValue: string) => void;
}

// Create a Context with a default empty implementation
const MyContext = createContext<MyContextType>({
  value: '',
  setValue: () => {},
});

// Provider component
export const MyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [value, setValue] = useState<string>('');

  return (
    <MyContext.Provider value={{ value, setValue }}>
      {children}
    </MyContext.Provider>
  );
};

// Custom hook for using the context
export const useMyContext = () => useContext(MyContext);
